import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";
import dayjs from "dayjs";

export class EditTemporaryRole {
  @Expose()
  @IsOptional()
  @IsString()
  roleId!: string | null;
  @Expose()
  @IsString()
  from!: string;
  @Expose()
  @IsString()
  to!: string;
  @Expose()
  @IsBoolean()
  isActivated!: boolean;

  constructor() {
    this.roleId = null;
    this.from = dayjs().format("YYYY-MM-DDTHH:mm:ss");
    this.to = dayjs().format("YYYY-MM-DDTHH:mm:ss");
    this.isActivated = false;
  }
}

export class EditTemporaryRoleModel extends EditTemporaryRole {
  @Expose()
  @IsOptional()
  @IsNumber()
  id!: number | null;

  constructor() {
    super();
    this.id = null;
  }
}
